export default __webpack_public_path__ + "static/media/bbamUSDC.fc62fb0b.png";